export default __webpack_public_path__ + "static/media/rabbit.9824b84b.svg";